import http, { url } from '../../http'

const API_URL = "management-review"

/** Ítem 6.1.3 — Acta de Revisión anual por la Alta Dirección (captura estructurada + PDF firmado). */
class ManagementReviewAPI {

  // Catálogo de los 15 temas del Decreto 1072 (para el editor).
  async meta() {
    const response = await http(`${API_URL}/meta`, 'GET')
    return response || null
  }

  async getAll(companyId, page = 1) {
    const response = await http(`${API_URL}/company/${companyId}?page=${page}`, 'GET')
    return response || null
  }

  async get(id) {
    const response = await http(`${API_URL}/${id}`, 'GET')
    return response || null
  }

  async save(data) {
    return await http(`${API_URL}/save`, 'POST', data)
  }

  async update(id, data) {
    return await http(`${API_URL}/update/${id}`, 'PUT', data)
  }

  async delete(id) {
    return await http(`${API_URL}/delete/${id}`, 'DELETE')
  }

  // Acta branded: la app genera el PDF y la alta dirección firma.
  pdfUrl(id) {
    return url(`${API_URL}/${id}/pdf`)
  }

  async sign(id, payload) {
    return await http(`${API_URL}/${id}/sign`, 'POST', payload)
  }

  async status(id) {
    return await http(`${API_URL}/${id}/status`, 'GET')
  }
}

export default new ManagementReviewAPI()
